'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
require('./Switch.css');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Layouts a group of checkboxes with 1 level of indent.
 */
var CheckboxSubgroup = function CheckboxSubgroup(_ref) {
  var children = _ref.children;
  return _react2.default.createElement('div', {
    className: 'c-checkbox-subgroup'
  }, children);
};
CheckboxSubgroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Children of the checkboxSubGroup */
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = CheckboxSubgroup;